import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const ProfileIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M2.18164 12.3867H13.8184C14.609 12.3868 15.25 13.0276 15.25 13.8184C15.2499 14.609 14.609 15.2499 13.8184 15.25H2.18164C1.39101 15.2499 0.750096 14.609 0.75 13.8184C0.75 13.0276 1.39095 12.3868 2.18164 12.3867ZM8 0.75C9.99564 0.75 11.6131 2.36769 11.6133 4.36328C11.6133 6.35904 9.99576 7.97754 8 7.97754C6.00424 7.97754 4.38672 6.35904 4.38672 4.36328C4.38691 2.36769 6.00436 0.75 8 0.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

ProfileIcon.displayName = 'ProfileIcon';
